import { createContext } from 'react';
import { selectedContentType, userType } from '../utils/state';
import { tabs, getFirstGroupData } from '../utils/state';
import { PopupIconOptionsType } from '../Components/Modals/PopupModal';

const stateContext: {
    user: userType,
    load: () => void,

    contentType: selectedContentType,
    setContentType: (e:any) => void,
    loadedDocument: any,
    setLoadedDocument: (e:any) => void,

    showPopup: (message: string, iconOption: PopupIconOptionsType) => void
    
} = {
    user: {shopname: "", email: "", plan: "", timeout: ""},
    load: () => {},

    contentType: {group: tabs[0].componentName, content: getFirstGroupData(tabs[0].groupData)},
    setContentType: (e) => {},
    loadedDocument: {},
    setLoadedDocument: (e) => {},

    showPopup: (e) => {}


};


export const StateContext = createContext(stateContext);

export const StateContextProvider = StateContext.Provider;
export const StateContextConsumer = StateContext.Consumer;
